var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", xs: "12", md: "2", xl: "3" } },
            [
              _c(
                "v-flex",
                { staticClass: "caption pt-1 pl-1" },
                [
                  _vm._v("\n        " + _vm._s(_vm.header) + "\n        "),
                  _vm.showHelpTextIdentifier != undefined &&
                  _vm.showHelpTextIdentifier.length > 0
                    ? _c(
                        "v-icon",
                        {
                          staticClass: "help-icon",
                          attrs: { dark: "" },
                          on: { click: _vm.showDialog }
                        },
                        [_vm._v("mdi-help-circle")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", xs: "12", md: "10", xl: "6" } },
            [_vm._t("default")],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm.helptTextDialog
        ? _c("popupDialog", { attrs: { dialogModel: _vm.helptTextDialog } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }